module.exports = __webpack_public_path__ + "static/media/Illus-Nutrition_1.1324f917.png";